"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IE11Flexbug3Fix = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
// See https://github.com/philipwalton/flexbugs#flexbug-3
const IE11Flexbug3Fix = (0, _styled.default)("div")`
    display: flex;
    flex-direction: column;
`;
exports.IE11Flexbug3Fix = IE11Flexbug3Fix;
//# sourceMappingURL=IE11Flexbug3Fix.js.map